module.exports = __webpack_public_path__ + "media/heroes/media-kit-hero-desktop-89005ccd.jpg";